export default {
    data: () => ({
        translations: {
            title: {
                el: "Ορίστε παρόχους πληρωμών για πληρωμές μέσω κινητού.",
                en: "Select payment providers for mobile payments on your merchandise.",
                it: "Configura uno o più fornitori di pagamenti mobili per la tua attività."
            },
            active: {
                el: "ΕΝΕΡΓΟ",
                en: "ACTIVE",
                it: "ATTIVO"
            },
            inactive: {
                el: "ΜΗ ΕΝΕΡΓΟ",
                en: "INACTIVE",
                it: "INATTIVO"
            },
            edit: {
                el: "ΕΠΕΞΕΡΓΑΣΙΑ",
                en: "EDIT",
                it: "MODIFICARE"
            },
            disable: {
                el: "ΑΠΕΝΕΡΓΟΠΟΙΗΣΗ",
                en: "DISABLE",
                it: "DISATTIVARE"
            },
            enable: {
                el: "Ενεργοποίηση",
                en: "enable",
                it: "Abilitare"
            },
            createProvider: {
                el: "Προσθήκη κλειδιών",
                en: "Enter Credentials",
                it: "Inserisci le credenziali"
            },
            updateProvider: {
                el: "Επεξεργασία Παρόχου",
                en: "Update Provider",
                it: "Aggiorna Fornitore"
            },
            disableProvider: {
                el: "",
                en: "Disable Provider",
                it: ""
            },
            areYouSure: {
                el: "",
                en: "Are you sure you want to disable",
                it: ""
            }
        }
    })
};
